/**
 * Detect if virtual-web is running embedded in the platform shell (e.g. at app.caribe7.local/virtual-sports)
 * vs standalone (e.g. at virtual-sports.caribe7.local).
 * Used to adjust layout (e.g. no min-height so platform footer shows underneath).
 */
export function isEmbeddedInPlatformShell() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/virtual-sports');
}
